import React from 'react';
import Slider from 'react-slick';
import Partnerimg01 from '../../../assets/images/footer-three/footer-three-patner-1.svg';
import Partnerimg02 from '../../../assets/images/footer-three/footer-three-patner-2.svg';
import Partnerimg03 from '../../../assets/images/footer-three/footer-three-patner-3.svg';
import Partnerimg04 from '../../../assets/images/footer-three/footer-three-patner-4.svg';

const Partner = () => {
    const PartnerSlider = ({
            speed: 5000,
            autoplay: true,
            autoplaySpeed: 0,
            cssEase: 'linear',
            slidesToShow: 5,
            slidesToScroll: 1,
            dots: false,
            arrows: false,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }
            ]
        })
            
    return (
        <>
            <div className="partner-section-five">
                <div className="container-fluid p-0">
                    <Slider className="partner-slider-five" {...PartnerSlider}>
                        <div className="partner-item-five">
                            <div className="partner-box-five">
                                <img
                                    src={Partnerimg01}
                                    alt="partner-logo"
                                />
                            </div>
                        </div>
                        <div className="partner-item-five">
                            <div className="partner-box-five">
                                <img
                                    src={Partnerimg02}
                                    alt="partner-logo"
                                />
                            </div>
                        </div>
                        <div className="partner-item-five">
                            <div className="partner-box-five">
                                <img
                                    src={Partnerimg03}
                                    alt="partner-logo"
                                />
                            </div>
                        </div>
                        <div className="partner-item-five">
                            <div className="partner-box-five">
                                <img
                                    src={Partnerimg04}
                                    alt="partner-logo"
                                />
                            </div>
                        </div>
                        <div className="partner-item-five">
                            <div className="partner-box-five">
                                <img
                                    src={Partnerimg01}
                                    alt="partner-logo"
                                />
                            </div>
                        </div>
                        <div className="partner-item-five">
                            <div className="partner-box-five">
                                <img
                                    src={Partnerimg01}
                                    alt="partner-logo"
                                />
                            </div>
                        </div>
                        <div className="partner-item-five">
                            <div className="partner-box-five">
                                <img
                                    src={Partnerimg01}
                                    alt="partner-logo"
                                />
                            </div>
                        </div>
                    </Slider>
                </div>
            </div>
        </>
    )
}

export default Partner;
